module.exports = __webpack_public_path__ + "media/images/custom_page/tempest/brand-15a9928e21ca8d7feed38d496878268e.png";